"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayExt = void 0;
var ArrayUtil_1 = require("@aelesia/commons/dist/src/collections/util/ArrayUtil");
function ArrayExt() {
    Array.prototype.max = function () {
        return ArrayUtil_1.ArrayUtil.max(this);
    };
    Array.prototype.isEmpty = function () {
        return ArrayUtil_1.ArrayUtil.isEmpty(this);
    };
    Array.prototype.random = function () {
        return ArrayUtil_1.ArrayUtil.random(this);
    };
    Array.prototype.first = function () {
        return ArrayUtil_1.ArrayUtil.first(this);
    };
    Array.prototype.last = function () {
        return ArrayUtil_1.ArrayUtil.last(this);
    };
}
exports.ArrayExt = ArrayExt;
//# sourceMappingURL=ArrayExt.js.map